import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { LanguageProvider } from "./contexts/LanguageContext";
import { InternalLinkProvider } from "./components/LinkedText";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <InternalLinkProvider>
          <AppRoutes />
        </InternalLinkProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
